import { Grid, Typography, Link, useMediaQuery } from '@mui/material'
import landingPageStyles from "../../Styles/ComponentStyles/LandingPage/LandingPage.module.scss"
import { useContext, useState } from 'react'
import { UserContext, UserContextPayload } from '../../Context/UserDetailContext'

const GLobalFooter = () => {
    const isBelow768 = useMediaQuery('(max-width:768px)')

    const {
        userDetail
    } = useContext(UserContext) as UserContextPayload

    return (
        <Grid
            container
            className={landingPageStyles.footer}
            direction={isBelow768 ? "column" : "row"}
            alignItems={isBelow768 ? "flex-start" : "center"}
            justifyContent="space-between"
        >
            {/* Copyright Section */}
            <Grid item>
                <Typography component={'span'} className={landingPageStyles.footerText}>
                    Copyright © All Rights Reserved {new Date().getFullYear()}.
                </Typography>
            </Grid>

            {/* Links Section */}
            <Grid
                item
            >
                <Grid container
                    gap={isBelow768 ? "5px" : "10px"}
                    // direction={isBelow768 ? "column" : "row"}
                    direction={"row"}
                    // alignItems={isBelow768 ? "flex-start" : "center"}
                    alignItems={"center"}
                    flexWrap="nowrap"
                >
                    {userDetail?.flagLoggedIn && (
                        <>
                            <Grid item>
                                <Typography component={'span'}>
                                    <Link href="/disclaimer" target='_blank' className={landingPageStyles.footerText}>Disclaimer</Link>
                                </Typography>
                            </Grid>
                            {/* {!isBelow768 && <Grid item className={landingPageStyles.footerText}>|</Grid>} */}
                            {<Grid item className={landingPageStyles.footerText}>|</Grid>}
                        </>
                    )}
                    <Grid item>
                        <Typography component={'span'}>
                            <Link href="/terms-and-conditions" target='_blank' className={landingPageStyles.footerText}>
                                {isBelow768 ? 'T&C' : 'Terms and Conditions'}
                            </Link>
                        </Typography>
                    </Grid>
                    {/* {!isBelow768 && <Grid item className={landingPageStyles.footerText}>|</Grid>} */}
                    {<Grid item className={landingPageStyles.footerText}>|</Grid>}
                    <Grid item>
                        <Typography component={'span'}>
                            <Link href="/privacy-policy" target='_blank' className={landingPageStyles.footerText}>Privacy Policy</Link>
                        </Typography>
                    </Grid>
                    {/* {!isBelow768 && <Grid item className={landingPageStyles.footerText}>|</Grid>} */}
                    {<Grid item className={landingPageStyles.footerText}>|</Grid>}
                    <Grid item>
                        <Typography component={'span'}>
                            <Link href="/user-agreement" target='_blank' className={landingPageStyles.footerText}>User Agreement</Link>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default GLobalFooter
